import { Injectable } from "@angular/core";
import { HttpClient } from "../../shared/wrappers/HttpClient";
import { Archive } from "../../models/archive/archive.model";
import { Consultant } from "../../models/Consultant.model";

@Injectable()
export class ArchiveService{
    constructor(private http:HttpClient){}

    endPoint: String = "/archives";

    async get(query?){
        return await this.http.get(`${this.endPoint}?${query}`);
    }

    async post(archive:Consultant){
        return await this.http.post(this.endPoint,archive);
    }

    async put(archive:Consultant,id:string){
        return await this.http.update(this.endPoint,id,archive);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/archive/archive.service.ts